if (!customElements.get('dut-quick-buy')) customElements.define('dut-quick-buy', class extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.variants = JSON.parse(this.querySelector('script').textContent);
    this.sticky = this.querySelector('.dut-quick-buy__sticky');
    this.stickyResize = new ResizeObserver(() => {
      document.body.style.setProperty('--dut-quick-buy-height', `${this.sticky.getBoundingClientRect().height}px`);
    });
    this.stickyResize.observe(this.sticky);
    this.chosen = this.dataset.single === 'true' || this.variants.length === 1;
    const signal = this.abort.signal;
    this.querySelectorAll('[data-quick-action]').forEach(button => button.addEventListener('click', () => {
      const form = document.getElementById(`product-form-${this.dataset.section}`);
      const submit = form?.querySelector('[type="submit"]');
      if (!this.chosen) {
        const picker = document.querySelector(`#ProductInfo-${this.dataset.section} variant-selects`);
        window.dutScrollTo(picker || form);
        picker?.querySelector('input,select,button')?.focus({ preventScroll: true });
      } else if (submit && !submit.disabled) submit.click();
    }, { signal }));
    this.update = () => {
      const form = document.getElementById(`product-form-${this.dataset.section}`);
      const variant = this.variants.find(v => String(v.id) === form?.querySelector('[name="id"]')?.value);
      const submit = form?.querySelector('[type="submit"]');
      const busy = !submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      this.querySelectorAll('[data-quick-action]').forEach(button => {
        button.disabled = this.chosen ? !variant?.available || busy : !this.variants.some(v => v.available);
        button.textContent = !this.chosen && this.variants.some(v => v.available) ? 'Choose options' : !variant?.available ? 'Sold out' : busy ? 'Please wait…' : 'Add to cart';
      });
      const freeDelivery = this.dataset.country === 'AU' && this.dataset.currency === 'AUD' && variant?.price >= 10000;
      const actionText = freeDelivery ? 'Add to cart\nWith FREE delivery' : 'Add to cart';
      if (variant?.available && !busy) {
        const label = submit?.querySelector('span');
        if (label && label.textContent.trim() !== actionText) label.textContent = actionText;
        if (this.chosen) this.querySelectorAll('[data-quick-action]').forEach(button => { button.textContent = actionText; });
      }
      if (variant) {
        document.querySelectorAll('[data-dut-installment]').forEach(el => {
          const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: this.dataset.currency || 'AUD', currencyDisplay: 'narrowSymbol' }).format(Math.round(variant.price / 4) / 100);
          if (el.textContent !== amount) el.textContent = amount;
        });
        this.querySelectorAll('[data-quick-price]').forEach(el => el.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: this.dataset.currency || 'AUD' }).format(variant.price / 100));
      }
      const rect = submit?.getBoundingClientRect();
      this.sticky.hidden = !window.matchMedia('(max-width: 749px)').matches || !variant?.available || !rect || rect.bottom > 0;
      document.body.classList.toggle('dut-quick-buy-visible', !this.sticky.hidden);
    };
    window.addEventListener('scroll', this.update, { passive: true, signal });
    window.addEventListener('resize', this.update, { passive: true, signal });
    window.addEventListener('dut:cart-open', () => { this.sticky.hidden = true; }, { signal });
    if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
      if (String(event.data.sectionId) === this.dataset.section) { this.chosen = true; requestAnimationFrame(this.update); }
    });
    this.observer = new MutationObserver(this.update);
    const info = document.getElementById(`ProductInfo-${this.dataset.section}`);
    if (info) this.observer.observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled','aria-disabled','value'] });
    this.update();
  }
  disconnectedCallback() { this.abort.abort(); this.observer?.disconnect(); this.stickyResize?.disconnect(); document.body.style.removeProperty('--dut-quick-buy-height'); this.unsubscribe?.(); document.body.classList.remove('dut-quick-buy-visible'); }
});

// Calendar dates and cutoff are always Melbourne-local, including daylight saving.
function dutDeliveryTiming(now = new Date()) {
  const zone = 'Australia/Melbourne';
  const parts = date => Object.fromEntries(new Intl.DateTimeFormat('en-AU', {
    timeZone: zone, year: 'numeric', month: 'numeric', day: 'numeric',
    hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23'
  }).formatToParts(date).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
  const local = parts(now);
  const tomorrow = local.hour >= 14;
  const target = Date.UTC(local.year, local.month - 1, local.day + Number(tomorrow), 14);
  let cutoff = target;
  for (let i = 0; i < 3; i++) {
    const p = parts(new Date(cutoff));
    cutoff += target - Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
  }
  const arrival = new Date(Date.UTC(local.year, local.month - 1, local.day + 3));
  return {
    date: new Intl.DateTimeFormat('en-AU', {timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long'}).format(arrival),
    minutes: Math.max(0, Math.ceil((cutoff - now.getTime()) / 60000)), tomorrow
  };
}
if (!customElements.get('dut-delivery-countdown')) customElements.define('dut-delivery-countdown', class extends HTMLElement {
  connectedCallback() {
    this.tick = () => {
      const timing = dutDeliveryTiming();
      const heading = this.querySelector('[data-delivery-date]');
      heading.replaceChildren(document.createTextNode('Estimated express delivery: '));
      const date = document.createElement('strong'); date.textContent = timing.date;
      heading.append(date);
      const timer = this.querySelector('[data-delivery-timer]');
      timer.hidden = false;
      timer.textContent = `${Math.floor(timing.minutes / 60)}hrs ${timing.minutes % 60}min`;
      timer.setAttribute('aria-label', `${Math.floor(timing.minutes / 60)} hours ${timing.minutes % 60} minutes until the next 2pm order cutoff`);
      this.querySelector('[data-delivery-day]').textContent = timing.tomorrow ? ' tomorrow' : ' today';
    };
    this.tick(); this.interval = setInterval(this.tick, 30000);
  }
  disconnectedCallback() { clearInterval(this.interval); }
});
